<template>
  <div class="role-list">
    <div class="role-list-section-head">
      <span class="role-list-section-head__bar"></span>
      <span class="role-list-section-head__title">角色列表</span>
    </div>
    <div class="role-list-header flex-box">
      <el-input
          class="search-input"
          placeholder="角色名称"
          prefix-icon="el-icon-search"
      >
      </el-input>
      <el-button type="primary" class="role-toolbar-btn" @click="addRoleClick">新增角色</el-button>
    </div>
    <div class="role-list-content">
      <div class="role-card">
        <RoleCard :roleInfoList="roleInfoList" :activeId="activeId" @updateRoleInfo="updateRoleInfo"></RoleCard>
      </div>
    </div>
    <!--    <div class="role-list-footer">-->
    <!--      <el-pagination-->
    <!--          v-if="roleInfoTotal > 0"-->
    <!--          background-->
    <!--          layout="prev, pager, next"-->
    <!--          :total="roleInfoTotal"-->
    <!--          :pager-count="5"-->
    <!--          @current-change="currentPageNumChange"-->
    <!--      >-->
    <!--      </el-pagination>-->
    <!--    </div>-->
  </div>
</template>

<script>
import RoleCard from "./RoleCard.vue";

export default {
  name: "RoleList",
  data() {
    return {
      reqRoleData: {
        name: "",
        pageNum: 1,
        pageSize: 10
      },
      roleInfoList: [],
      roleInfoTotal: 0,
      activeId: 0,
      isLoading: true,
    }
  },
  methods: {
    /**
     * 输入框失去焦点时，查询角色列表数据
     */
    searchInputChange() {
      this.getAllRoles();
    },
    /**
     * 点击左侧角色列表，向父级暴露角色信息
     */
    updateRoleInfo({item, index}) {
      this.activeId = index;
      this.$emit("updateRoleInfo", item);
    },
    /**
     * 新增角色按钮点击事件
     */
    addRoleClick() {
      this.activeId = -1;
      this.$emit("addRoleInfo");
    },
    /**
     * 分页按钮事件
     */
    currentPageNumChange(val) {
      this.reqRoleData.pageNum = val;
      this.getAllRoles(0);
    },
    /**
     * 查询角色列表
     * 传入角色id，选中角色
     * 默认选中第一个
     */
    getAllRoles(id = 0) {
      let index = 0;
      this.isLoading = true;
      this.$http.post(process.env.VUE_APP_API_HOST + "/api/get_role_list", {"req": this.reqRoleData}, {"content-type": "application/json"}).then(res => {
        console.log(res)
        if (res.data) {
          this.roleInfoList = res.data.data;
          if (id !== 0) {
            index = this.roleInfoList.findIndex(item => item.id === id);
          }
          this.roleInfoTotal = res.data.data.length;
          this.activeId = index;
          this.$emit("updateRoleInfo", this.roleInfoList[index]);
        }
        this.isLoading = false;
      });
    }
  },
  created() {
    this.getAllRoles();
  },
  mounted() {
  },
  components: {
    RoleCard
  }
}
</script>

<style lang="less" scoped>
.flex-box {
  display: flex;
  align-items: center;
}

.role-list {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;

  .role-list-section-head {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 18px;
    padding-bottom: 4px;
  }

  .role-list-section-head__bar {
    width: 4px;
    height: 18px;
    border-radius: 3px;
    background: linear-gradient(180deg, #47e09c 0%, #2ecd81 100%);
    box-shadow: 0 0 16px rgba(46, 205, 129, 0.28);
  }

  .role-list-section-head__title {
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 0.08em;
    color: rgba(255, 255, 255, 0.82);
  }

  .role-list-header {
    flex-shrink: 0;
    gap: 14px;
    margin-bottom: 20px;

    .search-input {
      flex: 1;
      min-width: 0;
    }
  }

  .role-list-content {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding-right: 4px;
    margin-right: -4px;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(255, 255, 255, 0.12);
      border-radius: 6px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }
  }

  .role-toolbar-btn {
    flex-shrink: 0;
    height: 40px;
    padding: 0 22px;
    font-weight: 500;
    border-radius: 10px;
    background-color: #2ecd81 !important;
    border-color: #2ecd81 !important;
    color: #fff !important;

    &:hover,
    &:focus {
      background-color: #26b872 !important;
      border-color: #26b872 !important;
    }
  }

  /deep/ .search-input .el-input__inner {
    height: 40px;
    line-height: 40px;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    background: rgba(0, 0, 0, 0.2);
    color: rgba(255, 255, 255, 0.9);

    &::placeholder {
      color: rgba(255, 255, 255, 0.35);
    }

    &:focus {
      border-color: rgba(46, 205, 129, 0.55);
    }
  }

  /deep/ .search-input .el-input__prefix {
    color: rgba(255, 255, 255, 0.35);
  }

  .role-list-footer {
    position: absolute;
    bottom: 0;
    height: 48px;

    /deep/ .el-pager {
      li {
        margin: 0;
      }
    }
  }
}
</style>
